    <div class="all">
        <div class="text">
            <h1>Em breve nosso site !!</h1>
        </div>
        <div class="imagem">
            <img src="../../assets/img/temp.PNG" alt="">
        </div>
    </div>